// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'

// Redux:
import { setConnectionStatus } from 'actions/site'

class Image extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			inViewport: false,
			downloadFullImage: false,
			fullImageLoaded: false,
			fullImageComplete: false,
			showManualDownload: false,
			showLoading: false,
			userTriggered: false
		}

		this.nativeConnection = !! window.navigator.connection
	}

	componentDidMount() {
		this.startTime = new Date().getTime()
	}

	componentWillReceiveProps( nextProps ) {
		const { url } = this.props

		if ( url != nextProps.url ) {
			this.setState({
				inViewport: false,
				downloadFullImage: false,
				fullImageLoaded: false,
				fullImageComplete: false,
				showManualDownload: false,
				userTriggered: false
			})
		}
	}

	onEnter = () => {
		if ( this.state.inViewport ) {
			return
		}

		this.setState( {
			inViewport: true
		} )

		const shouldAutoDownload = this.shouldAutoDownload()

		if ( shouldAutoDownload ) {
			this.setState( {
				downloadFullImage: true
			} )
		} else {
			this.setState( {
				showManualDownload: true
			} )
		}
	}

	onLeave = () => {
		const { fullImageLoaded } = this.state

		if ( ! fullImageLoaded && ! this.state.userTriggered ) {
			this.setState( {
				inViewport: false,
				downloadFullImage: false
			} )
		}
	}

	shouldAutoDownload = () => {
		const { connection } = this.props

		if ( connection.possiblySlowNetwork ) {
			return false
		}

		if ( ! connection.effectiveType ) {
			return true
		}

		const { downlink, rtt, effectiveType } = connection

		switch ( effectiveType ) {
			case 'slow-2g':
			case '2g':
				return false

			case '3g':
			case '4g':
			default:
				return true
		}
	}

	handleDownloadFullImage = ( e ) => {
		e.stopPropagation()
		e.preventDefault()

		this.setState({
			downloadFullImage: true,
			showManualDownload: false,
			showLoading: true,
			userTriggered: true
		})
	}

	handleThumbImageLoaded = () => {
		const { connection } = this.props

		// If connection info is known, don't try guessing.
		if ( connection.effectiveType ) {
			return
		}

		// Check load time. If slow, this might be a slow connection.
		const endTime = new Date().getTime()
		const latency = endTime - this.startTime

		if ( latency > 5000 ) {
			this.props.dispatch( setConnectionStatus( {
				possiblySlowNetwork: true
			} ) )
		}
	}

	handleFullImageLoaded = () => {
		this.setState({
			fullImageLoaded: true,
			showLoading: false
		})

		setTimeout( () => {
			this.setState({
				fullImageComplete: true
			})
		}, 1500 )
	}

	render() {
		let { wrapStyle, thumb, url, srcset, sizes, alt, focalPoint, width, height, aspectRatio, connection } = this.props
		let { downloadFullImage, fullImageLoaded, fullImageComplete, showManualDownload, showLoading } = this.state
		let wrapClass = fullImageLoaded ? 'ideal-image is-loaded' : 'ideal-image'

		if ( fullImageComplete ) {
			wrapClass += ' is-complete'
		}

		if ( ! wrapStyle ) {
			wrapStyle = {}
		}

		if ( ! url ) {
			url = siteData.default_post_image
			thumb = siteData.default_post_image
		}

		srcset = srcset ? srcset : undefined

		let imagePosition = '50% 50%'

		// Calculate CSS percentages to focus on the focal point:
		if ( focalPoint ) {
			let percentageX = ( focalPoint.x / width ) * 100
			let percentageY = ( focalPoint.y / height ) * 100

			// Ensure the image doesn't offset too much:
			if ( percentageX > 100 ) {
				percentageX = 100
			}

			if ( percentageY > 100 ) {
				percentageY = 100
			}

			imagePosition = percentageX.toFixed( 0 ) + '% ' + percentageY.toFixed( 0 ) + '%'
		}

		let imageStyle = {
			objectPosition: imagePosition
		}

		if ( aspectRatio ) {
			wrapStyle.paddingBottom = 100 / aspectRatio + '%'
		}

		return (
			<div className={ wrapClass } style={ wrapStyle }>
				<Waypoint onEnter={ this.onEnter } onLeave={ this.onLeave } />

				<img
					className="-thumb"
					src={ thumb }
					alt={ alt }
					onLoad={ this.handleThumbImageLoaded }
					style={ imageStyle }
				/>

				{ downloadFullImage &&
					<img
						className="-full"
						alt={ alt }
						src={ url }
						srcSet={ srcset }
						sizes={ sizes }
						onLoad={ this.handleFullImageLoaded }
						style={ imageStyle }
					/>
				}

				{ showManualDownload &&
					<div className="-download" onClick={ this.handleDownloadFullImage }>
						<i className="icon-arrow-circle-down-light" aria-hidden="true" />

						<div className="-download-text">
							Click to load
						</div>
					</div>
				}

				{ showLoading &&
					<div className="-loading">
						<i className="icon-cog-solid" aria-hidden="true" />
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		connection: state.site.connection
	}
}

export default connect( mapStateToProps )( Image )
